<template>
	<Layout>
		<Header>
			<export-default v-if="permissionEnabled('users', 'read')" endpoint="users" />
			<b-button v-if="permissionEnabled('users', 'create')" type="is-primary create" rounded @click="modalCreate($event)">
				<svg-icon icon="plus" class="icon is-small"></svg-icon>
				<span>{{ $t('buttons.add') }}</span>
			</b-button>
		</Header>
		<filter-default
			enable-search
			:filters="filters"
			@filterOrder="filterOrder"
			@filterStatus="filterStatus"
			@filterSearch="filterSearch">
			<b-field :label="$tc('menu.roles')" v-model="role" label-position="on-border">
                <b-select id="" :placeholder="$t('labels.all')" @input="filterRole">
                    <option v-for="r in permission" :value="r.id" :key="r.id" v-show="r.id != 3">{{ r.name }}</option>
                </b-select>
            </b-field>
		</filter-default>
		<Error v-if="errored" :icon="true" :back="true" />
		<Results v-if="users.length == 0 && !loading" />
		<div v-if="loading" class="columns is-multiline">
			<div v-for="n in pagination" :key="n" class="column is-12-mobile is-6-tablet is-4-desktop">
				<Placeholder />
			</div>
		</div>
		<transition-group name="filtering" class="filtering columns is-multiline mb-5" tag="div">
			<div v-for="u in users" :key="u.id" class="column is-12-mobile is-6-tablet is-4-desktop">
				<article :class="[!u.active ? 'block inactive' : 'block']" :style="{ 'border-left-color': u.permission ? u.permission.color : '#d5d5d5' }" @click.self="u.id != user.id ? modalEdit(u.id) : ''">
					<!-- <b-checkbox v-if="u.id != 1 && u.id != 2" class="block__checkbox" type="is-secondary" v-model="usersSelected" :native-value="u.id" :disabled="u.id == user.id" /> -->
					<div class="block__avatar image is-48x48" @click="u.id != user.id ? modalEdit(u.id) : ''">
						<b-tooltip v-if="u.permission" :label="u.permission.name" type="is-primary" position="is-right">
							<span class="block__role" :style="{ background: u.permission.color }"></span>
						</b-tooltip>
						<b-image ratio="1by1" :src="u.avatar" :alt="u.full_name" :rounded="true"></b-image>
					</div>
					<div class="block__content" @click="u.id != user.id ? modalEdit(u.id) : ''">
						<h3 class="block__name" translate="no">{{ u.full_name }}</h3>
						<p class="block__email is-ellipsis" translate="no">{{ u.email }}</p>
						<p class="block__email">{{ format(u.created_at) }} • {{ timeTo(u.created_at) }}</p>
					</div>
					<Trigger :id="u.id" v-if="u.id != user.id" :role="u.role ? u.role.name : ''" :name="u.full_name" :email="u.email" :active="u.active" :delete="u.deleted_at ? true : false" />
				</article>
			</div>
		</transition-group>
		<!--
		<div class="page__selection">
			<b-button size="is-small" class="is-rounded is-outlined is-secondary" @click="selectAllUsers()">
				<span v-if="usersSelected.length >= 15">{{ $t('labels.deselect_all') }}</span>
				<span v-else>{{ $t('labels.select_all') }}</span>
			</b-button>
			<b-button size="is-small" class="is-rounded is-outlined is-danger ml-3" @click="deleteUsersSelected()" :disabled="usersSelected.length == 0">{{ $tc('labels.delete_selected', usersSelected.length) }}</b-button>
		</div>
		-->
	</Layout>
</template>

<script>
import Layout from '@/layouts/Default'
import Header from '@/components/Header'
import Icon from '@/components/Icon'
import Placeholder from '@/components/placeholders/User'
import Trigger from '@/components/triggers/User'
import Error from '@/components/Error'
import Results from '@/components/Results'
import Modal from '@/components/modals/User'
import Api from '@/services/api'
import eventHub from '@/services/eventHub'
import { create, update } from '@/mixins/modal'
import { successToast, errorToast } from '@/mixins/toast'
import { mapGetters, mapState } from 'vuex'
import mixinApp from '@/mixins/app'
import FilterDefault from '@/components/FilterDefault'
import ExportDefault from '@/components/ExportDefault'

export default {
	components: {
		Layout,
		Header,
		Placeholder,
		Trigger,
		Error,
		Results,
		'svg-icon': Icon,
		FilterDefault,
		ExportDefault
	},
	mixins: [
		mixinApp
	],
	data() {
		return {
			// Pagination
			current: 1,
			page: 1,
			total: 0,
			pagination: 15,
			data: [],
			loading: true,
			errored: false,
			// Filter
			filter: {
				order: '',
				status: '1',
				role: '',
				name: ''
			},
			order: '',
			role: '',
			status: 1,
			permission: [],
			first_name: '',
			showPagination: false,
			destroy: false,
			usersSelected: [],
			filters: [
				{
					title: 'Ordem',
					function: 'filterOrder',
					options: [
						{ label: 'Nome', value: '1' },
						{ label: 'Email', value: '2' }
					]
				},
				{
					title: 'Status',
					function: 'filterStatus',
					options: [
						{ label: 'Ativo', value: '1' },
						{ label: 'Inativo', value: '2' }
					]
				},
			]
		}
	},
	async created() {
		const url = window.location.href.split('/')
		const type = url.find(el => el === 'page')
		if (type === 'page') {
			this.page = url[5]
			this.current = url[5]
		}
	},
	mounted() {
		this.getAllRoles()
		this.getAllUsers()
		eventHub.$on('edit-modal-users', obj => {
			update(this, 'users', obj.id, Modal, 'Edit', obj.root)
		})
		eventHub.$on('disable-users', async obj => {
			try {
				const response = await Api.put(`users/disable/${obj.id}`)
				const { status } = response
				if (status === 200) {
					// const { message } = response.data
					successToast(this.$t('alerts.status.disabled', [this.$tc('menu.users')]))
					await this.getAllUsers()
				}
			} catch (e) {
				console.log(e)
			}
		})
		eventHub.$on('delete-users', obj => {
			this.$buefy.dialog.alert({
				size: 'is-delete',
				type: 'is-outlined is-primary',
				title: this.$t('labels.warning'),
				message: '<span>' + this.$t('alerts.delete.confirmation') + '</span>',
				canCancel: true,
				focusOn: 'cancel',
				cancelText: this.$t('buttons.no'),
				confirmText: this.$t('buttons.yes'),
				onConfirm: async () => {
					try {
						const response = await Api.delete(`users/destroy/${obj.id}`)
						const { status } = response
						if (status === 200) {
							// const { message } = response.data
							successToast(this.$t('alerts.delete.success', [this.$tc('menu.users')]))
							await this.getAllUsers()
						} else {
							errorToast(this.$t('alerts.delete.error', [this.$tc('menu.users')]))
						}
					} catch (e) {
						console.log(e)
					}
				}
			})
		})
		eventHub.$on('restore-users', async obj => {
			try {
				const response = await Api.put(`users/restore/${obj.id}`)
				const { status } = response
				if (status === 200) {
					// const { message } = response.data
					successToast(this.$t('alerts.status.enabled', [this.$tc('menu.users')]))
					eventHub.$emit('reload-users')
				}
			} catch (e) {
				console.log(e)
			}
		})
		eventHub.$on('reload-users', () => {
			this.getAllUsers()
		})
	},
	computed: {
		users() {
			const url = window.location.href.split('/')
			const type = url.find(el => el === 'page')
			if (type === 'page') {
				let current = this.current - 1
				return this.data.slice(current * this.pagination, (current + 1) * this.pagination)
			} else {
				let current = this.current - 1
				return this.data.slice(current * this.pagination, (current + 1) * this.pagination)
			}
		},
		...mapGetters('user', [
			'permissionEnabled'
		]),
		...mapState('user', [
			'user'
		])
	},
	methods: {
		async getAllRoles() {
			try {
				const response = await Api.get('permission/findAll')
				const { status } = response
				if (status === 200) {
					const { data } = response
					this.permission = data
					this.permission.route = data.route
				}
			} catch (e) {
				console.log(e)
			}
		},
		async getAllUsers() {
			try {
				const response = await Api.get('users/findAll?status=' + (this.filter.status ? this.filter.status : '1'))
				const { status } = response
				if (status === 200) {
					const { data } = response
					this.data = data
					// console.log(data)
					this.total = data.length
					this.showPagination = this.total > 15 ? true : false
				}
			} catch (e) {
				console.log(e)
			} finally {
				this.loading = false
			}
		},
		async filterSearch(v) {
			try {
				this.filter.name = v
				if (v.length > 0) {
					const response = await Api.post('users/findByName', {
						name: this.filter.name,
						status: this.filter.status ? this.filter.status : null
					})
					const { status } = response
					if (status === 200) {
						const { data } = response
						this.data = data
						this.total = data.length
					}
				} else {
					await this.getAllUsers()
				}
			} catch (e) {
				console.log(e)
			} finally {
				this.loading = false
			}
		},
		async filterOrder(v) {
			try {
				this.filter.order = v
				const response = await Api.post('users/filterByOrder', {
					name: this.filter.order,
					status: this.filter.status ? this.filter.status : null
				})
				const { status } = response
				if (status === 200) {
					const { data } = response
					this.data = data
					this.total = data.length
				}
			} catch (e) {
				console.log(e)
			} finally {
				this.loading = false
			}
		},
		async filterStatus(v) {
			try {
				this.filter.status = v
				const response = await Api.post('users/filterByStatus', {
					name: this.filter.status
				})
				const { status } = response
				if (status === 200) {
					const { data } = response
					this.data = data
					this.total = data.length
				}
			} catch (e) {
				console.log(e)
			} finally {
				this.loading = false
			}
		},
		async filterRole(v) {
			try {
				this.filter.role = v
				const response = await Api.post('users/filterByRole', {
					name: this.filter.role,
					status: this.filter.status ? this.filter.status : null
				})
				const { status } = response
				if (status === 200) {
					const { data } = response
					this.data = data
					this.total = data.length
				}
			} catch (e) {
				console.log(e)
			} finally {
				this.loading = false
			}
		},
		modalCreate() {
			if (this.permissionEnabled('users', 'create')) {
				create(this, 'users', Modal, 'New')
			}
		},
		modalEdit(id) {
			if (this.permissionEnabled('users', 'edit')) {
				update(this, 'users', id, Modal, 'Edit')
			}
		},
		changeUrl(page) {
			this.current = page
			if (page === 1) {
				history.pushState({}, '', '/users')
			} else {
				history.pushState({}, '', '/users')
				history.pushState({}, '', `users/page/${this.current}`)
			}
		},
		selectAllUsers() {
			if (this.usersSelected.length == (this.data.length - 1)) {
				this.usersSelected = []
			} else {
				let users = this.data.filter(d => d.id != this.user.id)
				this.usersSelected = users.map((d) => {
					return d.id
				})
			}
		},
		deleteUsersSelected() {
			this.$buefy.dialog.alert({
				size: 'is-delete',
				type: 'is-outlined is-primary',
				title: this.$t('labels.warning'),
				message: '<span>' + this.$t('alerts.delete.confirmation') + '</span>',
				canCancel: true,
				focusOn: 'cancel',
				cancelText: this.$t('buttons.no'),
				confirmText: this.$t('buttons.yes'),
				onConfirm: async () => {
					Api.post('user/deleteMultiple', { ids: this.usersSelected })
						.then(() => {
							this.data = []
							this.usersSelected = []
							this.loading = true
							this.getAllUsers()
							successToast(this.$t('alerts.delete.multiple.success'))
						})
						.catch(() => {
							errorToast(this.$t('alerts.delete.multiple.error'))
						})
				}
			})
		}
	},
	destroyed() {
		eventHub.$off('edit-modal-users')
		eventHub.$off('disable-users')
		eventHub.$off('delete-users')
		eventHub.$off('restore-users')
		eventHub.$off('reload-users')
	}
}
</script>
